import palette from '@lib/core/src/theme/palette';
import { Box, Button, styled } from '@mui/material';

export const AgentCardContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'isAvailable'
})<{ isAvailable: boolean }>(({ isAvailable }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '12px',
  border: `1px solid ${palette.grey[1200]}`,
  width: '365px',
  maxWidth: '365px',
  height: '270px',
  pointerEvents: isAvailable ? 'auto' : 'none',
  '&:hover': {
    boxShadow: '0px 6px 8px -6px rgba(24, 39, 75, 0.12), 0px 8px 16px -6px rgba(24, 39, 75, 0.08)',
    cursor: 'pointer'
  }
}));

export const AgentImageContainer = styled(Box)({
  position: 'relative',
  height: '140px',
  borderTopLeftRadius: '12px',
  borderTopRightRadius: '12px',
  overflow: 'hidden',
  borderBottom: `1px solid ${palette.grey[1200]}`
});

export const AgentName = styled(Box, {
  shouldForwardProp: prop => prop !== 'isAvailable'
})<{ isAvailable: boolean }>(({ isAvailable }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '13px',
  fontWeight: 600,
  lineHeight: 1,
  textTransform: 'capitalize',
  color: isAvailable ? palette.black : palette.grey[500]
}));

export const ActivePlaceholder = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '11px',
  fontWeight: 500,
  lineHeight: 1,
  color: palette.grey[500],
  '&::before': {
    content: '""',
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: palette.green[300],
    marginRight: '8px'
  }
}));

export const AgentDescription = styled(Box)(() => ({
  fontSize: '11px',
  fontWeight: 500,
  flex: 1,
  color: palette.grey[500]
}));

export const ConfigureButton = styled(Button)({
  backgroundColor: palette.black,
  color: palette.white,
  borderRadius: '12px',
  padding: '5px 12px',

  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#444'
  }
});
export const ComingSoonTag = styled(Box)({
  position: 'absolute',
  top: '10px',
  left: '10px',
  padding: '5px 6px',
  fontSize: '11px',
  borderRadius: '4px',
  lineHeight: 1,
  border: `1px solid ${palette.grey[900]}`,
  color: palette.grey[500],
  background: palette.white
});

export const NewTag = styled(Box)({
  position: 'absolute',
  top: '10px',
  left: '10px',
  padding: '5px 6px',
  fontSize: '11px',
  borderRadius: '4px',
  fontWeight: 600,
  lineHeight: 1,
  border: `1px solid ${palette.blue[500]}`,
  background: palette.blue[600],
  color: palette.blue[700]
});
